import React, { useContext } from "react";
import "../ProgramList/ProgramList.scss";
import aurum from "../../../assets/images/aurum.png";
import exercise from "../../../assets/images/exercise.png";
import UserContext from "../../../services/context/userContext";
import Icon from "../../_default/Icon";
import FeatherIcon from "feather-icons-react"
export default function ExerciseListItem({ program, idx, removeProgram, from, ...props }) {
  const user = useContext(UserContext);
  return (
    <div className="c-exercise-list-item" key={idx}>
      <div className="c-exercise-list-item-data" onClick={() => props.history.push("/program", { update: true, from: from, program })}>
        <div className="c-exercise-image" style={{ backgroundImage: `url('${program.image}')` }} />
        <div className="c-exercise-text">
          <h3>{program.name}</h3>
          <span style={{ fontWeight: 300 }}>{program.phases} Phases - {program.weeks} Weeks</span>
        </div>
      </div>

      <div className="c-exercise-icons">
        {from === "aurum" ? (
          <div className="c-exercise-user-image" style={{ backgroundImage: `url('${aurum}')` }} />
        ) : (
          <div className="c-exercise-user-image" style={{ backgroundImage: `url('${user.image}')` }}>
            {user.image === "" && <p>{user.first_name[0] + user.last_name.match(/\b(\w)/g).join("")}</p>}
          </div>
        )}

        <div className="c-exercise-btns">
          {from === "aurum" && !user.admin ? (
            <>
            <div
                className="copy-btn"
                style={{ marginRight: "10px" }}
                onClick={() => props.history.push("/program", { update: false,copy:true, from: from, program })}
              >
                {/* Copy to trainer account */}
                Copy
                <FeatherIcon icon="copy" size="13" color="#000" />
              </div>
            </>
          ) : (
            <>
              <div
                className="copy-btn"
                style={{ marginRight: "10px" }}
                onClick={() => props.history.push("/program", { update: false,copy:true, from: from, program })}
              >
                {/* Copy to trainer account */}
                Copy
                <FeatherIcon icon="copy" size="13" color="#000" />
              </div>
              <button onClick={() => props.history.push("/program", { update: true, from: from, program })}>
                <Icon icon="edit" size={20} height={20} />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  removeProgram(program);
                }}
              >
                <Icon icon="trash" size={20} height={20} />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
